import { FC } from "react";

import { Box, Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { IconButton } from "@components/buttons";
import Icon from "@components/Icon";
import { LinkWrapper } from "@components/Link";

import type { TPageSwitcherProps } from "../types";

const PageSwitcher: FC<TPageSwitcherProps> = ({
  currentPage,
  totalPages,
  previousPageHref,
  nextPageHref,
  onPreviousPageClick,
  onNextPageClick,
}) => {
  const { t } = useTranslation();
  const isPreviousDisabled = currentPage === 1;
  const isNextDisabled = currentPage === totalPages;
  const shouldRenderButtons = totalPages > 1;
  return (
    <Flex align="center">
      {shouldRenderButtons && (
        <LinkWrapper href={!isPreviousDisabled ? previousPageHref : undefined}>
          <IconButton
            as={previousPageHref ? "a" : "button"}
            variant="transparent"
            size="sm"
            icon={<Icon icon="chevronLeft" size="1.25rem" />}
            title={t("common-pagination-previous_page")}
            name="previous-page"
            onClick={onPreviousPageClick}
            isDisabled={isPreviousDisabled}
            sx={{ visibility: isPreviousDisabled ? "hidden" : "visible" }}
          />
        </LinkWrapper>
      )}
      <Box>
        {currentPage} / {totalPages}
      </Box>
      {shouldRenderButtons && (
        <LinkWrapper href={!isNextDisabled ? nextPageHref : undefined}>
          <IconButton
            as={nextPageHref ? "a" : "button"}
            variant="transparent"
            size="sm"
            icon={<Icon icon="chevronRight" size="1.25rem" />}
            title={t("common-pagination-next_page")}
            name="next-page"
            onClick={onNextPageClick}
            isDisabled={isNextDisabled}
            sx={{ visibility: isNextDisabled ? "hidden" : "visible" }}
          />
        </LinkWrapper>
      )}
    </Flex>
  );
};
export default PageSwitcher;
